(function () {
  var TRANSITION_MS = 720;
  var TARGET_PATHS = [
    '/collections',
    '/products/',
    '/pages/'
  ];

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensureOverlay() {
    var existing = document.querySelector('[data-ruah-page-transition]');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.className = 'ruah-transition-overlay';
    overlay.setAttribute('data-ruah-page-transition', 'true');
    overlay.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < 5; index += 1) {
      var block = document.createElement('span');
      block.className = 'ruah-transition-block';
      overlay.appendChild(block);
    }

    document.body.appendChild(overlay);
    return overlay;
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function hasOptOut(link) {
    return link.hasAttribute('download') ||
      link.dataset.noTransition === 'true' ||
      link.closest('[data-no-transition]') ||
      link.closest('form') ||
      link.closest('[data-filter-drawer], .product-filter-drawer, .product-sort-form, .shopify-payment-button, .cart, cart-drawer, .drawer, .modal, [role="dialog"]');
  }

  function shouldTransition(link, event) {
    if (!link || !link.href || isModifiedClick(event) || prefersReducedMotion() || hasOptOut(link)) return false;
    if (link.target && link.target !== '_self') return false;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    var path = url.pathname;
    var eligible = TARGET_PATHS.some(function (target) {
      return path === target || path.indexOf(target) === 0;
    });

    if (!eligible) return false;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0 || path.indexOf('/account') === 0 || path.indexOf('/search') === 0) return false;
    if (url.href === window.location.href) return false;

    return true;
  }

  function startTransition(destination) {
    ensureOverlay();
    document.documentElement.classList.add('ruah-transition-active');

    window.setTimeout(function () {
      window.location.href = destination;
    }, TRANSITION_MS);
  }

  function initPageTransition() {
    if (document.documentElement.dataset.ruahTransitionReady === 'true') return;
    document.documentElement.dataset.ruahTransitionReady = 'true';

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!shouldTransition(link, event)) return;

      event.preventDefault();
      startTransition(link.href);
    }, true);

    window.addEventListener('pageshow', function () {
      document.documentElement.classList.remove('ruah-transition-active', 'ruah-transition-reveal');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageTransition);
  } else {
    initPageTransition();
  }
})();
